module.exports = __webpack_public_path__ + "img/test.57362240.png";